import { render, staticRenderFns } from "./DuplicarImovelDialog.vue?vue&type=template&id=ed4ed9f4&"
import script from "./DuplicarImovelDialog.vue?vue&type=script&lang=js&"
export * from "./DuplicarImovelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DuplicarImovelDialog.vue"
export default component.exports